"use client"

export function AgentHubView() {
    return (
        <div className="flex h-full items-center justify-center">
            <div className="text-center">
                <h1 className="text-2xl font-semibold text-muted-foreground">
                    Agent Hub
                </h1>
                <p className="mt-2 text-sm text-muted-foreground">
                    Coming Soon
                </p>
            </div>
        </div>
    )
}
